var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgNewVehicle = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 5.75V6.25C9.5 6.38807 9.38807 6.5 9.25 6.5H6.5V9.25C6.5 9.38807 6.38807 9.5 6.25 9.5H5.75C5.61193 9.5 5.5 9.38807 5.5 9.25V6.5H2.75C2.61193 6.5 2.5 6.38807 2.5 6.25V5.75C2.5 5.61193 2.61193 5.5 2.75 5.5H5.5V2.75C5.5 2.61193 5.61193 2.5 5.75 2.5H6.25C6.38807 2.5 6.5 2.61193 6.5 2.75V5.5H9.25C9.38807 5.5 9.5 5.61193 9.5 5.75Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.85 18.46C28.9495 18.8182 29 19.1882 29 19.56V27C29 27.5523 28.5523 28 28 28H27C26.4477 28 26 27.5523 26 27V26H14V27C14 27.5523 13.5523 28 13 28H12C11.4477 28 11 27.5523 11 27V19.56C10.9991 19.1849 11.0496 18.8114 11.15 18.45L12.59 13.45C12.8331 12.5998 13.6058 12.0101 14.49 12H25.49C26.3845 12.0026 27.1685 12.5987 27.41 13.46L28.85 18.46ZM14.51 13.75C14.3989 13.75 14.3011 13.8233 14.27 13.93L13.11 18H26.89L25.75 13.93C25.7189 13.8233 25.6211 13.75 25.51 13.75H14.51ZM16 22C16 22.5523 15.5523 23 15 23H14C13.4477 23 13 22.5523 13 22V21C13 20.4477 13.4477 20 14 20H15C15.5523 20 16 20.4477 16 21V22ZM26 23C26.5523 23 27 22.5523 27 22V21C27 20.4477 26.5523 20 26 20H25C24.4477 20 24 20.4477 24 21V22C24 22.5523 24.4477 23 25 23H26Z"
  })));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgNewVehicle, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/NewVehicle.8625f623.svg";
export { ForwardRef as ReactComponent };